import ActionTypes from 'core/actions/actionTypes';
import ServiceRegistry from 'core/util/ServiceRegistry';
import ILocalCacheService from 'core/service/cache/ILocalCacheService';


export const addToCart=(payload)=> {
    return {
      type: ActionTypes.ADD_TO_CART,
      payload: payload
    }
  }


  export const updateCart=(payload)=> {
    return {
      type: ActionTypes.UPDATE_CART,
      payload: payload
    }
  }

  export const saveCart = () => {
    return (dispatch, getState) => {
      const cartList = getState().cart;
      ServiceRegistry.get(ILocalCacheService).put("cart",cartList)
    }
  }

  export const clearCart = () => {
    return {
      type:ActionTypes.CLEAR_CART
    }
  }




// WEBPACK FOOTER //
// ./src/core/actions/cartActions.ts